import React, { useEffect, useState } from 'react'
import './assets/scss/styles.scss'
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs'
import Reference from '../../components/Reference'
import { getTerm, getParents, getParent, getTerms } from '../../assets/js/api'
import { Col, Container, Row } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import { linkTo, translate } from '../../assets/js/functions'
import parse, { attributesToProps } from 'html-react-parser'
import Modal from 'react-modal'
import classnames from 'classnames'
import ArrowPaginator from '../../components/ArrowPaginator/ArrowPaginator'
import { Helmet } from 'react-helmet'
import NotFoundMessage from '../../components/Errors/NotFoundMessage'
import ReactPageScroller from 'react-page-scroller'
import { FaTimes } from 'react-icons/fa'

export default function Captivity(props) {

    const navigate                              = useNavigate()
    const params                                = useParams()
    const [terms, setTerms]                     = useState([])
    const [popupTerm, setPopupTerm]             = useState([])
    const firstTerm                             = 'navarra106_1'
    const references                            = 'navarra106_138'
    const [currentTerm, setCurrentTerm]         = useState(params.id || firstTerm)
    const [modal, setModal]                     = useState(false)
    const [parents, setParents]                 = useState([])
    const [title, setTitle]                     = useState(null)
    const [currentPage, setCurrentPage]         = useState(0)
    const [color, setColor]                     = useState(null)
    const [showLast, setShowLast]               = useState(window.location.hash === "#b" ? true : false)
    const _terms                                = [firstTerm, 'navarra106_18', 'navarra106_44', 'navarra106_41', references]

    useEffect(() => {
        if (_terms.indexOf(currentTerm) > -1){
            fetchData()
            breadcrumbs()
            _checksControl()
        }
    }, [currentTerm, params.id])

    function _checksControl(){
        if (currentTerm === references){ navigate(linkTo('/map'), {replace: true}); window.location.reload(false); }
        getParent(currentTerm).then(res => setColor(res.data.result[0].body))
    }

    function fetchData(){
        _terms.map(
            val => {
                if (val === currentTerm){
                    getTerm(val).then( res => {
                        setTitle(res.data.result[0].term)
                        arrSetter(res.data.result)
                    }).then( _ => { getTerms(val).then( res => arrSetter(res.data.result) ) } )
                }
            }
        )
    }

    function breadcrumbs(){
        getParents(currentTerm).then(
            res => { 
                JSON.parse(res.data.result[0].parents).map(
                    term => getTerm(term).then(
                        response =>{
                            response.data.result[0] && setParents([{url: response.data.result[0].term_id, name: response.data.result[0].term}])
                        }
                    )
                )
            }
        )
    }

    function arrSetter(val){
        val.map(
            res =>{
                setTerms(terms => [...terms, res])
            }
        )
    }

    function _selectedReference(ref){
        getParent(ref).then(
            parent => {
                if (parent.data.result[0] && parent.data.result[0].parent === references){
                    getTerm(ref).then(
                        term => {
                            setPopupTerm(term.data.result[0])
                            setModal(true)
                        }
                    )
                }else{
                    if (ref){
                        setCurrentTerm(ref)
                        navigate(linkTo("/captivity/"+ref), {replace: true})
                        window.location.reload(false);
                    }
                }
            }
        )
    }

    function parseHtml(html){
        try{
            const options = {
                replace: domNode => {
                    if (domNode.attribs && domNode.name === 'reference') {
                    const props = attributesToProps(domNode.attribs);
                    return (<Reference
                        selectedReference={(ref) => _selectedReference(ref)}
                        pretag={'navarra106_'}
                        attr={props}
                        name={domNode} />)
                  }
                }
              };
            return parse(html, options);
        }catch(e){
            return null;
        }
    }

    function _paginator(val){
        setShowLast(false)
        handlePageChange(val)
    }


    function handlePageChange(number, next = false){
        if (number === "up" && currentPage === 0){
            if(_terms.indexOf(currentTerm) !== 0){
                var hash = ""
                if (_terms.indexOf(currentTerm)-1 !== 0) hash = "#b";
                navigate(linkTo('/captivity/'+_terms[_terms.indexOf(currentTerm)-1]+hash), {replace: true}); window.location.reload(false)
            }
        }
        if ((currentPage > 0 && currentPage === terms.length) || next){ navigate(linkTo('/captivity/'+_terms[_terms.indexOf(currentTerm)+1]), {replace: true}); window.location.reload(false)  }
        if (number === "up") currentPage-1 < 0 ? setCurrentPage(0) : setCurrentPage(currentPage-1)
        else if (number === "down"){
            // if (terms[currentPage+1]) navigate(linkTo('/captivity/'+terms[currentPage+1].term_id))
            setCurrentPage(currentPage+1)
        }
        else setCurrentPage(number);
    }

    function handleBeforePageChange(number){
        if (currentTerm === firstTerm && number === 1) handlePageChange("down", true)
    }

    function getIndexFromId(){
        if (window.location.hash === "#b" && showLast){
            if (currentPage === terms.length-1) setShowLast(false);
            return terms.length-1;
        }
        var index = 0
        if (currentPage !== 0) return currentPage
        terms.map(
            (res, i) => {
                if (res.term_id === params.id) index = i
            }
        )
        return index
    }

    function wheeled(val){
        if (currentPage === terms.length-1 && val > 0){ handlePageChange("down") }
        if (currentPage === 0 && val < 0){ handlePageChange("up") }
    }

    return (
        !!terms.length ?
        <>
            <div id="captivity" onWheel={(e) => wheeled(e.deltaY)}>
                {title && parents && <Breadcrumbs currentSite={title} currentSiteColor={color || null} staticData={parents} preUrl={"/captivity/"}/> }
                <Helmet><title>{title}</title></Helmet>
                <Container className={classnames("captivity", { active: currentTerm })}>
                    <Row className={'content'}>
                        <Col xs={10} md={11} className='expo'>
                        { !!terms.length && terms.length > 2 &&
                            <ReactPageScroller
                            pageOnChange={(val) => handlePageChange(val)}
                            onBeforePageScroll={(val) => handleBeforePageChange(val)}
                            containerHeight={'70vh'}
                            containerWidth={'auto'}
                            transitionTimingFunction={"ease"}
                            renderAllPagesOnFirstRender
                            customPageNumber={getIndexFromId()}>
                                { terms.map((v, i) =>   <div className="term_slide" key={i}>
                                                            <h1>{v.term}</h1>
                                                            <div className='description'>
                                                                { parseHtml(v.abstract) }
                                                            </div>
                                                        </div> || ""
                                    )
                                }
                            </ReactPageScroller>
                        }
                        </Col>
                           <Col xs={1}>
                                {
                                    <ArrowPaginator key={currentPage} 
                                                    upDisabled={_terms[0] === currentTerm && currentPage === 0}
                                                    firstTerm={currentPage === 0 && currentTerm !== firstTerm}
                                                    lastTerm={currentPage === terms.length-1}
                                                    downDisabled={currentPage === terms.length}
                                                    current={(val) => _paginator(val)}
                                                    min={0}/>
                                }
                            </Col>
                    </Row>
                </Container>
                <Modal
                        isOpen={modal}
                        onRequestClose={() => setModal(false)}
                        contentLabel="Modal"
                        ariaHideApp={false}
                    >
                    <Container>
                            <span className='clickable' onClick={() => setModal(false)}><FaTimes/></span>
                            <h2>{ popupTerm.term }</h2>
                            <span className="text">{ parseHtml(popupTerm.abstract) }</span>
                    </Container>
                </Modal>
            </div>
        </>
        : <NotFoundMessage className={"errorMessage"}/>
    )
}
